
import { useState } from "react";
import { ReservationService } from "../../application/services/reservationServices";

const reservationService = new ReservationService();

export const useReservation = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reservations, setReservations] = useState([]);

    const getActiveReservationsWithLinkedVms = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await reservationService.getActiveReservationsWithLinkedVms();
            if (result.success) {
                setReservations(result.data);
                return { success: true, data: result.data };
            } else {
                setError(result.message);
                return { success: false, message: result.message };
            }
        } catch (error) {
            setError(error.message);
            return { success: false, message: error.message };
        } finally {
            setLoading(false);
        }
    };

    return {
        getActiveReservationsWithLinkedVms,
        reservations,
        loading,
        error,
    };
};